export default "__VITE_ASSET__BUKyldxM__"